import { ChangeDetectionStrategy, Component, model, output, ViewEncapsulation } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { DropDownItem } from "../../pojo/DropDownItem";

@Component({
    selector: "s25-ng-quick-search",
    host: {
        "[class]": "'ngQuickSearchFilters'",
    },
    template: `
        <div class="ngListSearchInput">
            <input
                type="text"
                id="quickSearchInput"
                class="c-input ngListSearch"
                placeholder="Keyword Search"
                [(ngModel)]="searchTerm"
                (keyup.enter)="searchSubmit.emit()"
            />
        </div>
        <s25-ng-search-dropdown
            class="ngListDomainFilter"
            [type]="'event'"
            [allowNonQueryId]="false"
            [(value)]="selectedSearch"
        ></s25-ng-search-dropdown>
    `,
    // TODO: move old styles here:
    //  src/main/webapp/resources/shared/modules/s25-list-quick-search/css/s25-list-quick-search.scss
    styles: `
        :host {
            display: flex;
            gap: 0.5em;
            flex-wrap: wrap;
            justify-content: flex-start;
        }
        .ngListDomainFilter {
            min-width: min(20em, 100%);
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [S25DropdownPaginatedModule, FormsModule],
})
export class S25QuickSearchComponent {
    readonly searchTerm = model<string | undefined>(undefined);
    readonly selectedSearch = model<DropDownItem | undefined>(undefined);
    readonly searchSubmit = output<void>();
}

export type QuickSearch = {
    searchTerm?: string;
    selectedSearch?: string | number;
};
